const mapGCMSEnum = (str: string) => str.replace("_", " ");

export default mapGCMSEnum;
